// 誤ってSSR向けモジュールを使用してしまうケースの対策としてCSR向けのモジュールを再エクスポートしています。
// - @unleash/nextjs: SSR向けモジュール
// - @unleash/nextjs/client: CSR向けモジュール
export * from '@unleash/nextjs/client'

export { Provider as UnleashProvider } from './Provider'
